import "./NineGridRedPacketBoard.css";

export type NineGridVoucherState =
  | "available"
  | "used"
  | "pending"
  | "dispatching"
  | "completed"
  | "closed"
  | "disabled";

interface NineGridRedPacketBoardProps {
  state: NineGridVoucherState;
  selectedIndex: number | null;
  disabled?: boolean;
  onSelect: (index: number) => void;
}

const stateLabelMap: Record<NineGridVoucherState, string> = {
  available: "可抽紅包",
  used: "已抽完",
  pending: "等待客服",
  dispatching: "派發中",
  completed: "已完成",
  closed: "活動關閉",
  disabled: "尚未開放",
};

export function NineGridRedPacketBoard({
  state,
  selectedIndex,
  disabled = false,
  onSelect,
}: NineGridRedPacketBoardProps) {
  const isInteractive = state === "available" && !disabled;

  return (
    <section className="nine-grid-board" aria-label="9 宮格紅包">
      <div className="nine-grid-board__header">
        <div>
          <h3>9 宮格紅包</h3>
          <p>點選紅包會送出抽獎；點哪一格不會決定中獎金額。</p>
        </div>
        <span className={`nine-grid-board__status nine-grid-board__status--${state}`}>
          {stateLabelMap[state]}
        </span>
      </div>

      <div className="nine-grid-board__grid" role="group" aria-label="紅包格">
        {Array.from({ length: 9 }, (_, index) => {
          const cellNumber = index + 1;
          const isSelected = selectedIndex === index;

          return (
            <button
              type="button"
              className={`nine-grid-board__cell${isSelected ? " is-selected" : ""}`}
              key={cellNumber}
              disabled={!isInteractive}
              aria-label={`紅包格 ${cellNumber}`}
              aria-pressed={isSelected}
              onClick={() => onSelect(index)}
            >
              <span className="nine-grid-board__packet" aria-hidden="true">
                紅包
              </span>
              <span className="nine-grid-board__cell-index">{cellNumber}</span>
            </button>
          );
        })}
      </div>
    </section>
  );
}
